module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "gv-inverted-color-scheme",
    attrs: {
      "id": "gv-scuoladigitale-legend"
    }
  }, [_vm._c('div', {
    staticClass: "gv-scuoladigitale-legend-title gv-color-scheme",
    attrs: {
      "id": "gv-scuoladigitale-legend-title"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.title) + "\n    "), _vm._c('button', {
    class: _vm.toggleCollapseClass(),
    attrs: {
      "size": "mini",
      "title": "Nascondi Legenda"
    },
    on: {
      "click": _vm.hideLegend
    }
  })]), _vm._v(" "), _vm._c('div', {
    staticClass: "gv-scuoladigitale-legend-wrapper",
    attrs: {
      "id": "gv-scuoladigitale-legend-wrapper"
    }
  }, [_vm._c('div', [_vm._c('div', {
    staticClass: "gv-inverted-color-scheme",
    attrs: {
      "id": "gv-scuoladigitale-legend-body"
    }
  }, [_vm._c('gv-legend-maps', {
    attrs: {
      "options": _vm.options
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ac630c7e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ScuolaDigitaleLegend.vue
// module id = 903
// module chunks = 39